import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    variables: [],
    variableDefault: {
        id: null,
        bot_id: null,
        title: '',
        alias: '',
        type: 'number',
        form: 'normal',
        default_value: null,
        description: '',
        deleted: 0,
        min: null,
        max: null,
        change_time: null,
        change_time_unit: null,
        value_after_change: null,
        last_update: null,
        created_at: null
    },
    variablesListDefault: {
        bot_id: null,
        title: '',
        variables: null,
        created_at: null,
        deleted: 0,
        visible: 1
    },
    variablesLists: [],
    variablesListsLoaded: false,
    variablesLoaded: false,
    unsortedVariablesListId: 1,
    variablesClient: []
}
export default {
    state,
    getters,
    actions,
    mutations
}
